import { useEffect, useState } from "react";

const navItems = [
  { id: "overview", label: "内容类型" },
  { id: "movies", label: "最新电影" },
  { id: "series", label: "热播剧集" },
  { id: "western", label: "欧美大片" },
  { id: "domestic", label: "国产剧" },
  { id: "guide", label: "选片指南" },
  { id: "faq", label: "常见问题" },
];

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="h-[68px] w-full px-4 md:px-6 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
          <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-film-line text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading font-bold text-lg tracking-wide ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            >
              神马电影网
            </span>
            <span
              className={`text-[11px] mt-0.5 tracking-widest ${
                scrolled ? "text-foreground-600" : "text-background-200"
              }`}
            >
              MOVIE · SERIES · GUIDE
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`px-3 py-2 rounded-md text-sm transition-colors cursor-pointer ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-700 hover:bg-primary-100/70"
                  : "text-background-100 hover:text-background-50 hover:bg-white/10"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#movies"
            className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-play-circle-line"></i>
            开始浏览
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
              scrolled ? "text-foreground-900 hover:bg-background-100" : "text-background-50 hover:bg-white/10"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-b border-background-200 animate-fade-in">
          <nav className="px-4 py-3 grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-2.5 rounded-md text-sm text-foreground-800 bg-background-100 hover:bg-primary-100 hover:text-primary-800 transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}